export default "__VITE_ASSET__BJC0EUH$__"